import { Alert, Stepper, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import type { EscalationTrackerData } from '../api/result';
import { PORTAL_ESCALATION_STEPS } from '../utils/escalationStatus';

interface EscalationTrackerProps {
  tracker: EscalationTrackerData;
}

export default function EscalationTracker({ tracker }: EscalationTrackerProps) {
  // Default to false (vertical) so it never flashes horizontal on narrow screens.
  // getInitialValueInEffect: false evaluates the query synchronously on first render.
  const isWide = useMediaQuery('(min-width: 62em)', false, { getInitialValueInEffect: false });

  // Special states: render an alert instead of the linear step indicator.
  if (tracker.alertMessage) {
    return (
      <Alert color={tracker.alertColor ?? 'blue'} variant="light">
        <Text size="sm">{tracker.alertMessage}</Text>
      </Alert>
    );
  }

  const stepIndex = PORTAL_ESCALATION_STEPS.indexOf(tracker.step as typeof PORTAL_ESCALATION_STEPS[number]);
  const activeStep = tracker.step === 'Closed' ? PORTAL_ESCALATION_STEPS.length : Math.max(stepIndex, 0);

  return (
    <Stepper
      active={activeStep}
      size="sm"
      iconSize={28}
      orientation={isWide ? 'horizontal' : 'vertical'}
      className="portal-stepper"
      style={tracker.isPreview ? { opacity: 0.65 } : undefined}
      styles={isWide ? {
        step: { flexDirection: 'column', alignItems: 'center', gap: 8 },
        stepBody: { margin: 0, textAlign: 'center' },
        stepLabel: { whiteSpace: 'nowrap' },
      } : undefined}
    >
      <Stepper.Step label="Escalation Submitted" />
      <Stepper.Step label="Agent Assigned" />
      <Stepper.Step label="In Progress" />
      <Stepper.Step label="Closed" />
    </Stepper>
  );
}
